import React, { useState } from 'react'
import HeroSection from '../components/Landing/Hero'
import Features from '../components/Landing/Features'
import FAQ from '../components/Landing/FAQ'
import CTASection from '../components/Landing/CTASection'
import Footer from '../components/Landing/Footer'
import TopNavbar from '../components/TopNavbar'
import MobileNavbar from '../components/MobileNavbar'

const LandingPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="bg-[#FAF4F0]">
      <TopNavbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      {isMenuOpen && (
        <MobileNavbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      )}
      <HeroSection/>
      {/* Spacer section to create visual separation */}
      <div className="bg-[#FAF4F0] py-16 lg:py-24">
        <div className="max-w-[1200px] mx-auto px-4 text-center">
          <h2 className="mb-4 text-2xl font-bold text-gray-800 lg:text-4xl">
            Why Choose Dealboxx?
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-gray-600">
            Join thousands of vendors who trust us to promote their deals and reach more customers
          </p>
        </div>
      </div>
      <Features/>
      <FAQ/>
      <CTASection/>
      <Footer />
    </div>
  )
}

export default LandingPage